<ejs-maps
  id="ht-oa-container"
  style="display: block"
  [width]="mapWidth"
  [height]="mapHeight"
  [layers]="layers"
  (itemSelection)="itemSelection($event)"
></ejs-maps>
<!--<div class="flex items-center justify-between text-[0.9rem] text-dimot-1">
  <div class="flex flex-row gap-2 items-center"><span class="min-label">Chiusura</span>
 <div class="bg-[#C10007] w-[8px] h-[12px] rounded-l-full"></div>
  </div>
  <div class="flex flex-row gap-2 items-center">
 <div class="bg-[#008236] w-[8px] h-[12px] rounded-r-full"></div>
  <span class="max-label">Apertura</span>
  </div>
</div> -->
<div class="flex items-center gap-7 absolute bottom-4 right-[3px] font-sans w-full justify-center">
  <div  
  class="flex items-center gap-1.5">
      <span 
    class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] 2xl:w-[14px] 2xl:h-[14px] rounded-sm"
    [ngClass]="{
      'bg-[#C10007]': heatmapColorStatus === 'Red',
      'bg-white border border-gray-300': heatmapColorStatus === 'White'
    }"
  ></span>
    <h2 class="text-[0.62rem] xl:text-[0.65rem] 2xl:text-[0.75rem] text-gray-500">Chiusura</h2>
  </div>
  <div 
  class="flex items-center gap-1.5">
    <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] 2xl:w-[14px] 2xl:h-[14px] rounded-sm bg-[#008236]"></span>
    <h2 class="text-[0.62rem] xl:text-[0.65rem] 2xl:text-[0.75rem] text-gray-500">Inclusione</h2>
  </div>
</div>
